<template>
  <div class="tenancy-record dashboard">
    <h6
      v-if="loading"
      class="font-dark-gray"
    >
      <i class="rotation fa fa-refresh" />
      {{ $t('loading') }}
    </h6>
    <div v-show="tenancyRecords && tenancyRecords.length > 0">
      <div class="dashboard__title">
        {{ $t('company.titles.tenancyRecord') }}
      </div>
      <div class="dashboard__table">
        <table class="sort_table">
          <thead>
            <tr class="dashboard__table--header">
              <th
                v-for="header in tableHeaders"
                :key="header.name"
                :class="header.className"
                @click="sortBy(header.attr)"
              >
                <span>
                  {{ header.name }}
                  <i
                    v-if="sortingAttr === header.attr"
                    :class="[reverse ? 'triangle-down' : 'triangle-up']"
                  />
                </span>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="item in sortedRecords"
              :key="item.id"
              class="dashboard__table--body"
            >
              <td>
                <a
                  class="link_text"
                  @click="navToPage(item)"
                >
                  {{ item.companyName || emptyValue }}
                </a>
              </td>
              <td>{{ item.tradeName || emptyValue }}</td>
              <td>{{ translateTenancyType(item.type) }}</td>
              <td>{{ item.building || emptyValue }}</td>
              <td>{{ item.floor || emptyValue }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import lodash from 'lodash'
import { mapActions } from 'vuex'

import navigation from '@/utils/navigation'
import { getTenancyFloors } from '@/api/tenancies/util'

export default {
  name: 'TenancyRecords',
  props: {
    preload: {
      type: Boolean,
      default: false,
    },
    preloadedTenancies: {
      type: Array,
      default: [],
    },
  },

  data () {
    return {
      loading: true,
      tenancyRecords: [],
      emptyValue: '--',
      reverse: false,
      sortingAttr: 'companyName',
    }
  },
  computed: {
    tableHeaders () {
      return [
        {
          attr: 'companyName',
          name: this.$t('company.basic.companyName'),
          className: 'companyName',
        },
        {
          attr: 'tradeName',
          name: this.$t('company.tenancyRecord.tradeName'),
          className: 'tradeName',
        },
        {
          attr: 'type',
          name: this.$t('tenancy.type'),
          className: 'type',
        },
        {
          attr: 'building',
          name: this.$t('tenancy.building'),
          className: 'building',
        },
        {
          attr: 'floor',
          name: this.$t('tenancy.floor'),
          className: 'floor',
        },
      ]
    },
    sortedRecords () {
      const parsedTenancyRecords = this.tenancyRecords.map((rec) => {
        return {
          id: rec.id,
          companyName: lodash.get(rec, 'company.name'),
          tradeName: rec.tradeName,
          building: lodash.get(rec, 'building.fullName'),
          floor: getTenancyFloors(rec, true).join(', '),
          type: rec.type,
        }
      })
      const result = lodash.orderBy(parsedTenancyRecords, this.sortingAttr)
      return this.reverse ? result.reverse() : result
    },
  },
  async mounted () {
    try {
      if (this.preload) {
        this.tenancyRecords = this.preloadedTenancies
      } else {
        const tenancyRecords = await this.loadAllTenancies({ isViewAll: false, isSilentGet: true })
        this.tenancyRecords = tenancyRecords
      }
    } finally {
      this.loading = false
    }
  },
  methods: {
    ...mapActions('tenancyRecords', ['loadAllTenancies']),
    translateTenancyType (tenancyType) {
      return tenancyType ? this.$t(`tenancy.${tenancyType.toLowerCase()}`) : this.emptyValue
    },
    navToPage (item) {
      navigation.toPage(
        'ccdTenancyTenantView',
        { id: item.id },
      )
    },
    sortBy (attributePath) {
      if (this.sortingAttr === attributePath) {
        this.reverse = !this.reverse
      }
      this.sortingAttr = attributePath
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~styles/dashboard/tenant';
@import "~styles/animation";
.type {
  width: 10%;
}
.building {
  width: 20%;
}
.companyName {
  width: 30%;
}
.tradeName {
  width: 28%;
}
.floor {
  width: 12%;
}
</style>
